/* istanbul ignore file */
import type {CustomCssVarsFnParams, ShouldRenderVarsFnParams} from '@wix/wixstores-client-storefront-common';

export const getResponsiveLayoutCustomCssVars = ({styleParams, isMobile}: CustomCssVarsFnParams) => {
  let columnLayout;
  let shouldWrap;

  if (isMobile) {
    columnLayout = 'column';
    shouldWrap = 'nowrap';
  } else {
    columnLayout = styleParams.booleans.productPage_flipColumns ? 'row-reverse' : 'row';
    shouldWrap = 'wrap';
  }

  return {
    mediaColumnDirection: columnLayout,
    shouldWrapResponsiveFlexBox: shouldWrap,
  };
};

export const getResponsiveLayoutShouldRenderVars = ({booleans, isMobile}: ShouldRenderVarsFnParams) => {
  return {
    shouldRenderResponsiveLayoutNavigation: booleans.productPage_navigation || isMobile,
  };
};
